import { BAR_STATUS_CLASS, GanttBar } from "./ganttStatus";
import { PHASE_LOCATION_LABELS } from "./phaseLocation";

interface GanttPhaseRowProps {
  bar: GanttBar;
  row: number;
  columnFor: (date: Date) => number;
}

/**
 * One gantt row: the sticky phase label and its date-positioned bar.
 */
export function GanttPhaseRow({ bar, row, columnFor }: GanttPhaseRowProps) {
  return (
    <>
      <div
        className="sticky left-0 z-10 border-b bg-card py-1.5 pr-3"
        style={{ gridRow: row, gridColumn: 1 }}
      >
        <div className="truncate text-xs font-medium">{bar.phase.title}</div>
        <div className="truncate text-[10px] text-muted-foreground">
          {PHASE_LOCATION_LABELS[bar.phase.location]}
        </div>
      </div>
      <div
        className="border-b"
        style={{ gridRow: row, gridColumn: `2 / -1` }}
      />
      <div
        className={`my-2 h-3 self-center rounded-full ${BAR_STATUS_CLASS[bar.status]}`}
        style={{
          gridRow: row,
          gridColumn: `${columnFor(bar.barStart)} / ${columnFor(bar.barEnd) + 1}`,
        }}
      />
    </>
  );
}
